import React, { PropTypes } from 'react';
import Iframe from '../Iframe/Iframe';

const BildVR = props => {
  const { value } = props;
  const fil = (typeof value === 'string' && value) || (value && value.fil);
  const imageSettings = {
    src: 'https://quickshot-aframe.app.svt.se/image360/' + fil,
    storlek: (value && value.storlek) || "l",
    height: "56.25%",
    bildtext: value.bildtext,
    foto: value.foto,
    credit: value.credit
  };

  return (
    <Iframe value={imageSettings}/>
  );
};

BildVR.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
};

export default BildVR;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/BildVR/BildVR.js
 **/